import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { ILesson } from '../../../@types'
import services from '../../../services'

export function useData() {
  const [idSelected, setIdSelected] = useState<string | null>(null)

  const {
    data: lessons,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['/lessons'],
    queryFn: services.lessons.getAll,
  })

  const { data: modules } = useQuery({
    queryKey: ['/modules'],
    queryFn: services.modules.getAll,
  })

  const getLessonById = (id: string) => {
    const lesson: ILesson | null =
      lessons?.find((item) => item?.id === id) ?? null

    return lesson
  }

  return {
    isLoading,
    error,
    lessons,
    refetch,
    getLessonById,
    idSelected,
    setIdSelected,
    modules,
  }
}
